import { queryOptions, useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { getVendorByPath, type Vendor } from '@/services/matching.service';
import { shopStore } from '@/store/shopStore';

export function vendorQueryOptions(vendorPath: string) {
    return queryOptions<Vendor | null>({
        queryKey: ['vendor', 'byPath', vendorPath],
        queryFn: async () => {
            const result = await getVendorByPath({ vendorPath });
            const vendor = result && result.length > 0 ? result[0] : null;
            if (vendor) {
                shopStore.getState().setShop(vendor);
            }
            return vendor;
        },
        staleTime: 10 * 60 * 1000,
        gcTime: 30 * 60 * 1000,
        enabled: !!vendorPath,
    });
}

export function useVendorInfo(vendorPathOverride?: string) {
    const params = useParams<{ vendorPath: string }>();
    const vendorPath = vendorPathOverride || params.vendorPath || '';

    const { data, isLoading, isError, error } = useQuery(vendorQueryOptions(vendorPath));

    return {
        vendor: data ?? null,
        isLoading,
        isError,
        error,
    };
}
